import React from 'react';
import { Grid } from '@material-ui/core';
import { MediaStyles } from './styles';
import {
  ExclamationCircleIcon,
} from '../../../../../components/icon/solid';

const UploadFailMedia = () => {
  const classes = MediaStyles();

  return (
    <Grid item>
      <div className={classes.loader}>
        <ExclamationCircleIcon className={classes.errorIcon} />
      </div>
      <p className={`${classes.renderStatus} ${classes.renderStatusError}`}>
        Upload error, please delete and upload again
      </p>
    </Grid>
  );
};

export default UploadFailMedia;
